<template>
  <router-view v-if="user"></router-view>
</template>

<script>
export default {
  name: "Panel",
  components: {},
  data() {
    return {};
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.request({
        url: this.endpoint("sobhanAdmin/currentAdmin/"),
        method: "get",
        success: (data) => {
          this.$store.commit("setUser", data);
        },
      });
    },
  },
};
</script>